import HomeSnap from "./HomeSnap";

function HomeMain() {
  return (
    <>
      {/* <Navbar /> */}
      {/* <HomeHero /> */}
      <HomeSnap />
      {/* <HomeHero /> */}
      
    </>
  );
}

export default HomeMain;
